// @flow

import type { HTMLAST } from './types';

const isZapTemplateNode = (node: HTMLAST) => {
  return (
    node.tagName &&
    node.tagName === 'div' &&
    node.attrs &&
    node.attrs['data-zap-template-list'] === 'true'
  );
};

export default isZapTemplateNode;
